import React from 'react';
import Axios from 'axios';
import { createRoot } from 'react-dom/client';
//import { hydrateRoot } from 'react-dom/client';
import ShopProfile from './shopProfile';
import MenuProfile from './menuProfile';
import '../mainCSS/pc-menu.css';

export default class PcMenu extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            main: [],
            sub: [],
            mainRoot: null,
            subRoot: null,
            subPicRoot: null,
            loadMainMenu: false
        }
    }

    /*componentDidMount() {
        var url = ShopProfile.getURL() + '/index/reactFetch.php';
        var data = new URLSearchParams({
            event: 'menu-data',
            reverse: false
        });
        Axios.post(url, data)
            .then(res => {
                this.setState({
                    main: res.data['main'],
                    sub: res.data['sub']
                })
                MenuProfile.setMainMenu(Object.values(res.data['main']));
                MenuProfile.setSubMenu(Object.values(res.data['sub']));
                MenuProfile.setStatMenu(res.data['stat']);
            })
    }*/

    menuHeightCheck(data) {
        var sum = data.length;
        var subSum = 0;
        var sData = MenuProfile.getSubMenu();
        for (var i = 0; i < data.length; i++) {
            for (var si = 0; si < sData.length; si++) {
                if (sData[si].main === data[i].name) {
                    subSum++;
                }
            }
            if (subSum > sum) {
                sum = subSum;
            }
            subSum = 0;
        }
        return sum;
    }

    mainMenuShow() {
        document.getElementById('main').style.display = 'block';
        var { loadMainMenu } = this.state;
        var { mainRoot } = this.state;
        var mHeight = 0;
        if (mainRoot === null) {
            mainRoot = createRoot(document.getElementById('main'));
            this.setState({ mainRoot: mainRoot })
        }
        if (loadMainMenu === false) {
            this.setState({ loadMainMenu: true });
            var data = MenuProfile.getMainMenu();
            mHeight = this.menuHeightCheck(data);
            var element = document.getElementById("main");
            element.style.height = mHeight * 35 + 'px';
            const res = data.map((d) =>
                <li id={'mi-' + d.id} onMouseOver={() => this.subMenuShow(d.id, d.name, mHeight)} onMouseOut={() => this.subMenuPicHide(d.id)} key={d.id}>
                    <a href={ShopProfile.getURL() + '/' + d.link}>
                        {d.name}
                    </a>
                    {d.sub !== "undefined" && d.sub > 0 ? <span><i>{d.sub}</i></span> : ''}
                </li>
            );
            setTimeout(function () {
                mainRoot.render(res);
            }, 400);
        }
    }

    mainMenuHide() {
        document.getElementById('main').style.display = 'none';
        document.getElementById('sub').style.display = 'none';
    }

    mainMenuColor() {
        document.getElementById("mi-" + MenuProfile.getMainMenuId()).style.background = '#a4989c';
    }

    mainMenuClear() {
        let tabEl = document.getElementById("mi-" + MenuProfile.getMainMenuId());
        if (tabEl) {
            document.getElementById("mi-" + MenuProfile.getMainMenuId()).style.removeProperty("background");
        }
        //document.getElementById("mi-" + MenuProfile.getMainMenuId()).style.removeProperty("background");
        //document.getElementById("#shop ul li ul li").style.removeProperty("background");
    }

    subMenuCompiles(name) {
        var res = [];
        var item = [];
        var x = 0;
        var data = MenuProfile.getSubMenu();
        for (var i = 0; i < data.length; i++) {
            if (data[i].main === name) {
                item['id'] = data[i].id;
                item['name'] = data[i].name;
                item['link'] = data[i].link;
                res[x] = Object.assign({}, item);
                x++;
            }
        }
        item['id'] = 0;
        item['name'] = '';
        item['link'] = '';
        x++;
        res[x] = Object.assign({}, item);
        return res;
    }

    subMenuHide() {
        document.getElementById('sub').style.display = 'none';
    }

    getSubPic(pic, name) {
        if (pic.length === 0) {
            pic = ShopProfile.getURL() + '/image/aruhaz/default-stamp';
        }
        return (
            <img src={pic + '.jpg'} alt={name + ' kategória kép'} />
        )
    }

    subMenuPicHide(mainId) {
        document.getElementById('pic').style.display = 'none';
        //leveszem over színt is a main li tag -ról
        //this.mainMenuClear();
        /*document.getElementById("mi-" + mainId).style.removeProperty("background");
        document.getElementById("#shop ul li ul li").style.removeProperty("background");*/
    }

    subMenuPicShow(id, name, mainId) {
        //hovert színt rakok az érkező main li tag -re
        //document.getElementById("mi-" + mainId).style.background = '#a4989c';
        var pic = null;
        var url = ShopProfile.getURL() + '/index/reactFetch.php';
        var data = new URLSearchParams({
            event: 'menu-pic',
            id: id,
            reverse: false
        });
        Axios.post(url, data)
            .then(res => {
                pic = this.getSubPic(res.data, name);
            })
        var { subPicRoot } = this.state;
        if (subPicRoot === null) {
            subPicRoot = createRoot(document.getElementById('pic'));
            this.setState({ subPicRoot: subPicRoot })
        }
        setTimeout(function () {
            subPicRoot.render(pic);
            document.getElementById('pic').style.display = 'block';
        }, 200);
    }

    subMenuShow(mainId, name, mHeight) {
        var data = [];

        document.getElementById('sub').style.display = 'block';
        data = MenuProfile.getMainMenu();
        var element = document.getElementById("sub");
        element.style.height = mHeight * 35 + 'px';
        if (mainId !== null) {
            if (mainId !== MenuProfile.getMainMenuId()) {
                MenuProfile.setMainMenuId(mainId);
            }
        }

        var { subRoot } = this.state;
        if (subRoot === null) {
            subRoot = createRoot(document.getElementById('sub'));
            this.setState({ subRoot: subRoot })
        }
        data = this.subMenuCompiles(name);
        const res = data.map((d) =>
            <li id={d.id === 0 ? 'pic' : 'si-' + d.id} key={d.id} onMouseOver={() => this.subMenuPicShow(d.id, d.name, mainId)} onMouseOut={() => this.subMenuPicHide(mainId)}>
                {d.id !== 0 ? <a href={ShopProfile.getURL() + '/' + d.link}>{d.name}</a> : ''}
            </li>
        );
        if (res.length > 3) {
            subRoot.render(res);
        }
        this.mainMenuColor();
    }

    render() {
        return (
            <ul onMouseOver={() => this.mainMenuShow()} onMouseOut={() => this.mainMenuHide()}>
                <li>
                    <a href={ShopProfile.getURL() + '/top/kellek'}>
                        <span>{'Termékek'}</span>
                    </a>
                    <ul id='main' onMouseOverCapture={() => this.mainMenuClear()} onMouseOut={() => this.mainMenuClear()}></ul>
                    <ul id='sub' onMouseOver={() => this.subMenuShow(null)} onMouseOut={() => this.subMenuHide()}></ul>
                </li>
            </ul>
        )
    }

}